<template>
  <base-dialog :title="$t('store.editStore')" :openDialog="openEditDialog">
    <el-form
      :model="form"
      :rules="validator"
      ref="form"
      label-position="top"
      @submit.native.prevent
    >
      <el-row :gutter="50" class="row-input">
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('store.name')" prop="name">
            <el-input class="input" v-model="form.name" autocomplete="off">
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="form.name = ''"
                v-if="form.name"
              ></i>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('store.email')" prop="email">
            <el-input class="input" v-model="form.email" autocomplete="off">
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="form.email = ''"
                v-if="form.email"
              ></i>
            </el-input>
          </el-form-item> </el-col
      ></el-row>

      <el-row :gutter="50" class="row-input"
        ><el-col :xs="24" :sm="12">
          <el-form-item :label="$t('store.phone')" prop="phone">
            <el-input
              class="input"
              v-model="form.phone"
              autocomplete="off"
              @input="acceptNumber"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="form.phone = ''"
                v-if="form.phone"
              ></i>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('store.address')" prop="address">
            <el-input
              type="textarea"
              :rows="1"
              class="input"
              v-model="form.address"
              autocomplete="off"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <span class="dialog-footer">
          <el-button
            class="btn btn--cancel"
            @click="handleCloseEditDialog('form')"
            >{{ $t('store.cancelBtn') }}</el-button
          >
          <el-button
            class="btn btn--submit"
            :disabled="editStoreLoading"
            @click="submitForm('form')"
          >
            {{ $t('store.editBtn') }}
          </el-button>
        </span>
      </el-form-item>
    </el-form>
  </base-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { storeService } from '@/services/store.service';
import { convertHalfWidth, handleError, notifyMessage } from '@/helper';
import { phone, name, address, email } from '@/helper/validate';
const BaseDialog = () => import('@/components/Dialog');

export default {
  name: 'EditStoreDialog',
  components: { BaseDialog },
  props: {
    openEditDialog: Boolean,
  },
  data() {
    return {
      editStoreLoading: false,
      form: {},

      validator: {
        name: [{ validator: name, trigger: 'blur' }],
        phone: [{ validator: phone, trigger: 'blur' }],
        email: [{ validator: email, trigger: 'blur' }],
        address: [{ validator: address, trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapGetters('store', ['store']),
  },
  methods: {
    ...mapActions('store', ['getDetail']),
    handleCloseEditDialog(form) {
      this.$refs[form].resetFields();
      this.$emit('handleCloseEditDialog');
    },
    submitForm(form) {
      const { id } = this.$router.currentRoute.params;

      this.$refs[form].validate((valid) => {
        if (valid) {
          this.editStoreLoading = true;
          return storeService
            .edit(
              {
                name: this.form.name.trim(),
                phone: this.form.phone.trim(),
                address: this.form.address.trim(),
                email: this.form.email ? this.form.email.trim() : null,
              },
              id
            )
            .then(() => {
              this.getDetail({ id });
              this.$emit('handleCloseEditDialog');
              notifyMessage(this.$t('common.editSuccess'), 'success');
            })
            .catch((error) => {
              handleError(error);
            })
            .finally(() => {
              this.editStoreLoading = false;
            });
        }
      });
    },
    acceptNumber(value) {
      this.form.phone = convertHalfWidth(value);
    },
  },
  mounted() {
    this.form = { ...this.store };
  },
  watch: {
    'form.email'() {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate('email');
      }
    },
    'form.name'() {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate('name');
      }
    },
    'form.phone'() {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate('phone');
      }
    },
    'form.address'() {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate('address');
      }
    },
  },
};
</script>
